export function getSubsubProgress(ss, inProgressUnits = 0) {
  const planned = Number(ss.time ?? 0);
  const safePlanned = Number.isFinite(planned) ? planned : 0;

  const remainingRaw = ss.finishAfterReport ?? safePlanned;
  const remaining = Number(remainingRaw);
  const safeRemaining = Number.isFinite(remaining) ? remaining : safePlanned;

  const hasPlanned = safePlanned > 0;
  const adjustedRemaining = hasPlanned ? (safeRemaining - inProgressUnits) : safeRemaining;
  const workedRatio = hasPlanned ? (safePlanned - adjustedRemaining) / safePlanned : 0;

  return {
    planned: safePlanned,
    remaining: safeRemaining,
    remainingDisplay: adjustedRemaining,
    workedRatio: Math.min(1, Math.max(0, workedRatio)),
  };
}
